import Cookie from "js-cookie";

const SSO_AUTH_TYPE_COOKIE = "auth_type";

export type SsoAuthType = "legacy" | "auth0" | "unknown";

const KNOWN_AUTH_TYPES: ReadonlyArray<Exclude<SsoAuthType, "unknown">> = ["legacy", "auth0"];

function cookieOptions() {
  // Security invariant: auth_type is only a routing hint, but must still use
  // explicit cookie attributes to avoid browser-default drift across apps.
  const isSecureContext = typeof window !== "undefined" && window.location.protocol === "https:";

  return {
    path: "/",
    domain: import.meta.env.VITE_SSO_COOKIE_DOMAIN as string,
    sameSite: "lax" as const,
    secure: import.meta.env.PROD || isSecureContext,
  };
}

export function getSsoAuthType(): SsoAuthType {
  const value = Cookie.get(SSO_AUTH_TYPE_COOKIE);
  if (!value) return "unknown";

  if (KNOWN_AUTH_TYPES.includes(value as Exclude<SsoAuthType, "unknown">)) {
    return value as Exclude<SsoAuthType, "unknown">;
  }

  return "unknown";
}

export function setSsoAuthType(type: Exclude<SsoAuthType, "unknown">): void {
  Cookie.set(SSO_AUTH_TYPE_COOKIE, type, cookieOptions());
}

export function clearSsoAuthType(): void {
  Cookie.remove(SSO_AUTH_TYPE_COOKIE, cookieOptions());
}

export function shouldAttemptLocalAuthBootstrap(authType: SsoAuthType, hasAttemptedLocalProbe: boolean): boolean {
  if (hasAttemptedLocalProbe) return false;

  // Security invariant: local Auth0 probe only runs for explicit prior Auth0
  // state. Unknown state falls back to canonical admin login redirect.
  return authType === "auth0";
}
